export default {
  items: [],
  isModalOpen: false,
  carouselToUpdate: {
    id: null,
    description: '',
    link: '',
    imageLink: '',
    active: true,
  },
  carouselItemsToUpdateOrder: [],
};
